import { Component, OnInit, OnDestroy, Directive, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { Router } from '@angular/router';

import { AppConstants } from 'appshared/app-constants';
import * as Models from 'appshared/shared-models';
import { TextTools } from 'appshared/text-tools';
import { MiscTools } from 'appshared/misc-tools';
import { ValidationTools } from 'appshared/validation-tools';

import { AuthService } from 'client/app/services/auth.service';
import { UiAlertsService } from 'client/app/components/ui-alerts/ui-alerts.service';

import { PagingSearchBarComponent } from 'client/app/components/shared/paging-search-bar/paging-search-bar.component';

@Component({
	selector: 'app-table-zens',
	templateUrl: './table-zens.component.html',
	styleUrls: ['./table-zens.component.scss']
})
export class TableZensComponent implements OnInit {
	ac = AppConstants;
	tt = TextTools;
	mt = MiscTools;

	now = new Date();

	@ViewChild(PagingSearchBarComponent) pagingSearchBar: PagingSearchBarComponent = null;

	/*
		pass in
			users 
			storageKey
			options
			- showOrganization : true
	*/

	authUser: Models.AuthUser = null;
	loading: boolean = false;
	starIcon = ['fas', 'star'];

	displayOptions: Models.TableDisplayOptions = new Models.TableDisplayOptions();
	pagingOptions: Models.TablePagingOptions = new Models.TablePagingOptions();
	storageKey: string = '';

	showFavorite: boolean = false;
	showSalesEng: boolean = true;
	showSalesRep: boolean = true;

	items: Models.ZenMasterCustomer[] = [];
	itemsToShow: Models.ZenMasterCustomer[] = [];

	columnDefs: Models.ColumnDefinition[] = [
		{
			field: 'is_enabled',
			type: 'baseNumeric',
			sortType: 'numeric',
			label: null,
			toolTip: 'Enabled/Disabled',
			icon: 'power-off'
		}, {
			field: 'dns_prefix',
			type: 'baseText',
			sortType: 'text',
			label: 'Prefix',
			toolTip: null,
			icon: null
		}, {
			field: 'name',
			type: 'baseText',
			sortType: 'text',
			label: 'Name',
			toolTip: null,
			icon: null
		}, {
			field: '__zenType',
			type: 'baseText',
			sortType: 'text',
			label: 'Type',
			toolTip: null,
			icon: null
		}, {
			field: 'assessment',
			type: 'baseText',
			sortType: 'text',
			label: 'Assessment',
			toolTip: null,
			icon: null
		}, {
			field: '__notifyWarning',
			type: 'baseNumeric',
			sortType: 'numeric',
			label: null,
			toolTip: 'At Least One User Will Get ZEN Master Notifications from ZCP',
			icon: AppConstants.sectionIcons.mynotifications
		}, {
			field: '__orgName',
			type: 'baseText',
			sortType: 'text',
			label: 'Organization',
			toolTip: null,
			icon: null
		}, {
			field: '__accountOwnerShort',
			type: 'baseText',
			sortType: 'text',
			label: null,
			toolTip: 'Account Owner',
			icon: ['fab', 'salesforce']
		}, {
			field: '__seShort',
			type: 'baseText',
			sortType: 'text',
			label: null,
			toolTip: 'SE',
			icon: 'user-graduate'
		}, {
			field: '__tamShort',
			type: 'baseText',
			sortType: 'text',
			label: null,
			toolTip: 'TAM',
			icon: 'user-ninja'
		}, {
			field: '__saShort',
			type: 'baseText',
			sortType: 'text',
			label: null,
			toolTip: 'SA/Solutions Architect',
			icon: 'user-astronaut'
		}, {
			field: 'created_days',
			type: 'baseNumeric',
			sortType: 'numeric',
			label: null,
			toolTip: 'Days since added',
			icon: 'clock'
		}, {
			field: 'last_login_days',
			type: 'baseNumeric',
			sortType: 'numeric',
			label: null,
			toolTip: 'Days since last login',
			icon: 'sign-in-alt'
		}, {
			field: '__zenUsage',
			type: 'baseNumeric',
			sortType: 'numeric',
			label: null,
			toolTip: 'ZEN Master (Non-MediaConnect) Usage (Last ' + AppConstants.assessmentThresholdDays + ' Days)',
			icon: AppConstants.protocolIcon
		}, {
			field: '__mcUsage',
			type: 'baseNumeric',
			sortType: 'numeric',
			label: null,
			toolTip: 'ZEN Master (MediaConnect) Usage (Last ' + AppConstants.assessmentThresholdDays + ' Days)',
			icon: AppConstants.protocolIcon
		}, {
			field: 'num_active_bx',
			type: 'baseNumeric',
			sortType: 'numeric',
			label: null,
			toolTip: '# Active Broadcasters',
			icon: 'bolt'
		}, {
			field: '__marketplace',
			type: 'baseText',
			sortType: 'text',
			label: null,
			toolTip: 'Marketplace',
			icon: AppConstants.sectionIcons.marketplace
		}
	];

	fieldsToShow: string[] = [];
	allFieldsToShow: string[] = [];
	lockedFields: string[] = [];
	baselineFields: string[] = [];
	minimalFields: string[] = [];

	cachingUsageInfo: string = '';

	// ------------------------------------------------------------------------
	constructor(
		private router: Router,
		private uiAlertsService: UiAlertsService,
		private authService: AuthService) {
	}

	// ------------------------------------------------------------------------
	ngOnInit(): void {
		const sessionUser: Models.AuthUser = this.authService.getUser();
		if (sessionUser != null && sessionUser.id !== 0) {
			this.authUser = sessionUser;
			const starPref = TextTools.getUserPropValue(this.authUser, AppConstants.starIconKey);
			if (starPref && starPref !== '') this.starIcon = ['fas', starPref];

			this.setups();
		} // if
	}

	// ------------------------------------------------------------------------
	async setups() {

	}

	// ------------------------------------------------------------------------
	updateContent(items: Models.ZenMasterCustomer[], storageKey: string, options: any = {}) {
		this.loading = true;

		this.items = items;
		this.storageKey = storageKey;

		let optionKeys: string[] = [];
		if (options) optionKeys = Object.keys(options);

		if (optionKeys.includes('showshowFavoriteSalesEng')) this.showFavorite = options.showFavorite;
		if (optionKeys.includes('showSalesEng')) this.showSalesEng = options.showSalesEng;
		if (optionKeys.includes('showSalesRep')) this.showSalesRep = options.showSalesRep;

		this.fieldsToShow = [];
		this.allFieldsToShow = [];
		this.lockedFields = [];
		this.baselineFields = [];
		this.minimalFields = [];
		for (const cd of this.columnDefs)
			this.fieldsToShow.push(cd.field);

		for (const item of this.items) {
			item['__zenType'] = this.getZenType(item);
			item['__marketplace'] = this.getMarketplace(item);
		} // for

		this.pagingSearchBar.setupPaging(this.items, this.columnDefs, this.storageKey, 'name', 'asc');

		this.loading = false;
	} // updateContent

	// ------------------------------------------------------------------------
	getZenType(zc: Models.ZenMasterCustomer) {
		if (zc.zcp_type && zc.zcp_type !== '')
			return AppConstants.zenMasterTypeLabels[zc.zcp_type];
		return '';
	}

	// ------------------------------------------------------------------------
	displayDays(numDays: number) {
		if (numDays == null) return 'Never';

		const numYears = Math.abs(numDays / 365.25);
		if (numYears > 1.25)
			return numYears.toFixed(1) + ' years';

		return numDays.toLocaleString() + ' day' + (numDays > 1 ? 's' : '');
	}

	// ------------------------------------------------------------------------
	getMarketplace(zc: Models.ZenMasterCustomer) {
		if (zc.marketplace != null && zc.marketplace.marketplace !== '')
			return zc.marketplace.marketplace;
		return '';
	}

	// ------------------------------------------------------------------------
	filterItems(matchWords: string[]): any[] {

		const tmpList: Models.ZenMasterCustomer[] = [];
		for (const item of this.items) {
			let match: boolean = true;
			if (matchWords.length > 0) {
				let matches: number = 0;
				for (const w of matchWords) {
					if (item.dns_prefix.toLowerCase().includes(w)
						|| (item.name && item.name.toLowerCase().includes(w))
						|| (item.assessment && item.assessment.toLowerCase().includes(w))
						|| (item['__zenType'] && item['__zenType'].toLowerCase().includes(w))
						|| (item['__orgName'] && item['__orgName'].toLowerCase().includes(w))
						|| (item['__accountOwner'] && item['__accountOwner'].toLowerCase().includes(w))
						|| (item['__accountOwnerShort'] && item['__accountOwnerShort'].toLowerCase().includes(w))
						|| (item['__se'] && item['__se'].toLowerCase().includes(w))
						|| (item['__seShort'] && item['__seShort'].toLowerCase().includes(w))
						|| (item['__runtime_state'] && item['__runtime_state'].toLowerCase().includes(w))
					)
						matches++;
				} // for
				if (matches !== matchWords.length) match = false;
			} // if

			if (match) tmpList.push(item);
		} // for

		return tmpList;
	} // filterItems

	// ------------------------------------------------------------------------
	setSortBy(field: string) {
		this.pagingSearchBar.setSortBy(field);
	} // setSortBy

	// ------------------------------------------------------------------------
	// Catch calls from the paging/search bar
	// ------------------------------------------------------------------------
	getParentMethod(): any {
		return {
			filterItems: (matchWords: string[]) => {
				return this.filterItems(matchWords);
			},
			updateItemsToShow: (itemsToShow: any[], displayOptions: Models.TableDisplayOptions, pagingOptions: Models.TablePagingOptions) => {
				this.itemsToShow = itemsToShow;
				this.displayOptions = displayOptions;
				this.pagingOptions = pagingOptions;
			},
			updateFieldsToShow: (fieldsToShow: string[]) => {
				this.fieldsToShow = fieldsToShow;
			},
			setPageNum: (pageNum: number, uniqueId: string) => {
				if (this.pagingSearchBar) this.pagingSearchBar.setPageNum(pageNum);
			},
			setSortBy: (field: string) => {
				this.setSortBy(field);
			}
		}
	}

}
